<template>
    <vue-plyr :options="options">
        <video>
            <source :src="skolyStorage + subor" />
        </video>
    </vue-plyr>
</template>

<script>
import EventService from "@/services/EventService";

export default {
    components: {},
    props: [
        'subor',
    ],
    data() {
        return {
            options: {controls: [], clickToPlay: false, autoplay: false, muted: true}
        }
    },
    computed: {
        skolyStorage() {
            return EventService.getUlohyStorageUrl()
        },
    },
}
</script>
